// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineDislike = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.7996 22.0999C10.5096 22.0999 10.2196 22.0499 9.94955 21.9499C8.69955 21.5399 7.89955 20.1599 8.17955 18.8799L8.66955 15.7299C8.67955 15.6599 8.67955 15.5599 8.60955 15.4799C8.55955 15.4299 8.48955 15.3999 8.40955 15.3999H4.40955C3.42955 15.3999 2.57955 14.9899 2.07955 14.2799C1.58955 13.5899 1.48955 12.6799 1.80955 11.7999L4.19955 4.5199C4.56955 3.0699 6.11955 1.8999 7.71955 1.8999H11.5196C12.0796 1.8999 13.2996 2.0699 13.9496 2.7199L16.9796 5.0599L16.0596 6.2499L12.9596 3.8499C12.7096 3.5999 12.0796 3.3999 11.5196 3.3999H7.71955C6.81955 3.3999 5.84955 4.1199 5.64955 4.9299L3.22955 12.2799C3.06955 12.7199 3.09955 13.1199 3.30955 13.4099C3.52955 13.7199 3.92955 13.8999 4.41955 13.8999H8.41955C8.93955 13.8999 9.41955 14.1199 9.74955 14.4999C10.0896 14.8899 10.2396 15.4099 10.1596 15.9499L9.65955 19.1599C9.53955 19.7199 9.91955 20.3499 10.4596 20.5299C10.9396 20.7099 11.5796 20.4499 11.7996 20.1299L15.8996 14.0299L17.1396 14.8699L13.0396 20.9699C12.5696 21.6699 11.6796 22.0999 10.7996 22.0999Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.6191 18.1H18.6191C16.7691 18.1 15.8691 17.23 15.8691 15.45V5.65C15.8691 3.87 16.7691 3 18.6191 3H19.6191C21.4691 3 22.3691 3.87 22.3691 5.65V15.45C22.3691 17.23 21.4691 18.1 19.6191 18.1ZM18.6191 4.5C17.5291 4.5 17.3691 4.76 17.3691 5.65V15.45C17.3691 16.34 17.5291 16.6 18.6191 16.6H19.6191C20.7091 16.6 20.8691 16.34 20.8691 15.45V5.65C20.8691 4.76 20.7091 4.5 19.6191 4.5H18.6191Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineDislike };
